import { render } from "./ModalHistoryMessage.vue?vue&type=template&id=3f9b64c1&scoped=true"
import script from "./ModalHistoryMessage.vue?vue&type=script&lang=js"
export * from "./ModalHistoryMessage.vue?vue&type=script&lang=js"

import "./ModalHistoryMessage.vue?vue&type=style&index=0&id=3f9b64c1&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9b64c1"]])

export default __exports__